import * as React from "react";

interface StepImageProps {
    imageUrl: string;
}

export class StepImage extends React.Component<StepImageProps, {}> {

    render() {
        const styles = this.getStyles();

        return (
            <div className="image-container">
                <img src={this.props.imageUrl} style={styles.stepImage} />
            </div>
        );
    }

    private getStyles() {
        return {
            stepImage: {
                width: "100%"
            },
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/StepImage.tsx
 **/